import { connect } from 'react-redux';
import Field from '#components/pages/Components/support/form/ComponentFormTableField/ComponentFormTableField.jsx';
import getFullyQualifiedFieldName from '#support/utility/form/getFullyQualifiedFieldName.js';
import { selectFieldIsVisible, selectFieldValue } from '#selectors/ui/form/component.js';

const mapStateToProps = (state, ownProps) => {
  const { item, field } = ownProps;
  const { name } = field;
  const fullyQualifiedName = getFullyQualifiedFieldName(item, name);
  return {
    fullyQualifiedName,
    value: selectFieldValue(state, { name: fullyQualifiedName }),
    visible: selectFieldIsVisible(state, { name: fullyQualifiedName }),
  };
};
export default connect(mapStateToProps)(Field);
